module.exports = __webpack_public_path__ + "static/media/envelope.28273fe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/envelope.svg
// module id = 363
// module chunks = 0